import { message } from 'antd';
import { setSpinProps } from '@/utils/utils';
import {
  queryBuildingList,
  deleteBuilding,
  addBuilding,
  getBuildingInfo,
} from '../services/services';

const initState = () => {
  return {
    /**
     * 寝室入住列表 Array<Object>
     * buildingName	string 楼名
     * buildingType	string
     * createUser	string
     * gmtCreate	number
     * gmtModify	nullnumber
     * id	number
     * isDelete	number
     * modifyUser	string
     * orgId	string
     */
    list: [],
    buildingInfo: {},
    visible: false, // 新增modal状态
    // 加载状态
    spinProps: {
      spinning: false,
      tip: '加载中...',
    },
  };
};

export default {
  namespace: 'dormitoryBuilding',

  state: initState(),

  effects: {
    // 获取寝室入住列表
    *fetchList(_, { call, put }) {
      try {
        yield setSpinProps({ put, spinning: true, tip: '加载中...' });

        const content = yield call(queryBuildingList);
        yield put({
          type: 'fetchBuildingInfo',
        });
        yield setSpinProps({
          put,
          list: content,
        });
      } catch (error) {
        yield setSpinProps({ put });
      }
    },
    // 删除
    *fetchDelete({ params }, { call, put }) {
      try {
        yield setSpinProps({ put, spinning: true, tip: '删除中...' });

        yield call(deleteBuilding, params);

        message.success('删除成功');
        yield setSpinProps({ put });

        yield put({
          type: 'fetchList',
        });
      } catch (error) {
        yield setSpinProps({ put });
      }
    },

    // 新增
    *fetchAdd({ params }, { call, put }) {
      try {
        yield setSpinProps({ put, spinning: true, tip: '新增中...' });

        yield call(addBuilding, params);

        message.success('新增成功');
        yield setSpinProps({ put, visible: false });

        yield put({
          type: 'fetchList',
        });
      } catch (error) {
        yield setSpinProps({ put });
      }
    },
    *fetchBuildingInfo(_, { call, put }) {
      try {
        yield setSpinProps({ put, spinning: true, tip: '加载中...' });
        const content = yield call(getBuildingInfo);
        yield setSpinProps({
          put,
          buildingInfo: content,
        });
      } catch (error) {
        yield setSpinProps({ put });
      }
    },
  },

  reducers: {
    save(state, { payload }) {
      return {
        ...state,
        ...payload,
      };
    },
    reset() {
      return { ...initState() };
    },
  },
};
